import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getAllProjectPhasesSelector = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>{
        var _ref;
        var _project_data_templateId_template_templateContent, _project_data_templateId;
        return (_ref = (_project_data_templateId = project.data[templateId]) === null || _project_data_templateId === void 0 ? void 0 : (_project_data_templateId_template_templateContent = _project_data_templateId.template.templateContent) === null || _project_data_templateId_template_templateContent === void 0 ? void 0 : _project_data_templateId_template_templateContent.projectPhases) !== null && _ref !== void 0 ? _ref : [];
    });
export const useGetAllProjectPhasesInTemplate = ()=>{
    const templateId = useActiveTemplateId();
    const templateObject = useMemo(getAllProjectPhasesSelector, []);
    return useSelector((state)=>templateObject(state, templateId));
};
